export const calculateExpirationTime = (expiryTimeInMs) => {
  const expiryDate = new Date();
  try {
    expiryDate.setTime(expiryDate.getTime() + expiryTimeInMs);
    return parseInt(expiryDate.getTime() / 1000);
  } catch (e) {
    console.error("Error calculating expiry time " + e);
  }
};

export const isValidZipCode = (deliveryZipCode) => {
  if (deliveryZipCode) {
    return /^\d{5}$/.test(deliveryZipCode.toString().trim());
  }
  return false;
};
